module.exports = __webpack_public_path__ + "static/img/4.10f1e5a8.png";